import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'

interface Signature {
  Element: HTMLTableElement
}

export const LessonGuideTableFastPhonics: TOC<Signature> = <template>
  <table ...attributes>
    <thead>
      <tr>
        <th class="table-box table-box-header bg-juicy-orange-200 text-center" colspan="3">
          {{t "tables.lessonGuide.headers.fp.title"}}
        </th>
      </tr>
      <tr class="h-20">
        <th class="table-box table-box-header bg-juicy-orange-100 w-1/3 text-center">
          {{t "tables.lessonGuide.headers.fp.peaks1"}}
        </th>
        <th class="table-box table-box-header bg-juicy-orange-100 w-1/3 text-center">
          {{t "tables.lessonGuide.headers.fp.peaks2"}}
        </th>
        <th class="table-box table-box-header bg-juicy-orange-100 w-1/3 text-center">
          {{t "tables.lessonGuide.headers.fp.peaks3"}}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="table-box table-box-cell bg-juicy-orange-50 p-2 text-center">
          {{t "tables.lessonGuide.values.fp.phase2"}}
        </td>
        <td class="table-box table-box-cell bg-juicy-orange-50 p-2 text-center">
          {{t "tables.lessonGuide.values.fp.phase3"}}
        </td>
        <td class="table-box table-box-cell bg-juicy-orange-50 p-2 text-center">
          {{t "tables.lessonGuide.values.fp.phase4-5"}}
        </td>
      </tr>
    </tbody>
  </table>
</template>

export default LessonGuideTableFastPhonics
